/// <reference path="posHardware.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PosHardware {
    class PosHardwareController extends Meevo.Components.CommonClasses.CommonControllerBase {
		// statically inject constructor resources
		static $inject = [
			"meevo.AppSettings",
			"meevo.components.common.BusinessInfoDataService",
			"meevo.components.modal.ModalService",
			"meevo.components.common.IdentityService",
			"meevo.components.logging.LoggingService",
			"meevo.components.common.SecurityService",
			"meevo.components.tracking.TrackingService",
			"$rootScope",
			"$scope",
			"$state",
			"meevo.ContextParams",
			'meevo.components.short-cuts.ShortCutsService',
			"meevo.components.busy.BusyService",
			"meevo.components.common.PrintService",
            "$q",
            "$translate"
		];

		constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
			protected dataService: Meevo.Components.Common.PosHardwareDataService,
			protected modalService: Meevo.Components.Modal.IModalService,
			protected identityService: Meevo.Components.Common.IIdentityService,
			protected loggingService: Meevo.Components.Logging.ILoggingService,
			protected securityService: Meevo.Components.Common.ISecurityService,
			protected trackingService: Meevo.Components.Tracking.ITrackingService,
			protected $rootScope: angular.IRootScopeService,
			protected $scope: angular.IScope,
			protected $state: any,
			protected contextParams: Meevo.IContextParams,
			protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
			protected busyService: Meevo.Components.Busy.IBusyService,
			protected printService: Meevo.Components.Common.IPrintService,
            protected $q: ng.IQService,
            private $translate: angular.translate.ITranslateService) {

			super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

			this.createContext();
		}

		createContext(): void {
			this.busyService.start();
			this.securityService.checkSection(this.meevoSecurityKeys.REGISTER_POSHARDWARE).then(() => {
				this.busyService.stop();
				this.context = new PosHardwareContext(
					this.appSettings,
					this.dataService,
					this.modalService,
					this.identityService,
					this.loggingService,
					this.securityService,
					this.trackingService,
					this.printService,
					this.$q,
					this.$rootScope,
					this.$state,
                    this.$translate
				);
				super.createContext();
			});
		}
	}

	angular.module("meevo.plugins.posHardware")
		.controller("meevo.plugins.posHardware.PosHardwareController", PosHardwareController);
}